export default {
    name : 'gravity',

    init()
    {
        this.run();
    },
    run ()
    {
        this.initLabels();
    },

    initLabels()
    {
        const fields = document.querySelectorAll(".gfield input, .gfield textarea");

        fields.forEach((field) => {
            field.addEventListener('focus', this.toggleLabel);
            }
        );

        fields.forEach((field) => {
                field.addEventListener('blur', this.blurFields);
            }
        );
    },

    toggleLabel(event)
    {
        const gField = this.closest(".gfield");
        gField.classList.add('active');
    },

    blurFields()
    {
        const fields = document.querySelectorAll(".gfield input, .gfield textarea");
        fields.forEach((field) => {
                if (!field.value) {
                    let gField = field.closest(".gfield");
                    gField.classList.remove('active');
                }
            }
        );
    },

}